import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

const getEnvConfig = () => {
  const username = window._env_?.REACT_APP_AUTH_USERNAME || process.env.REACT_APP_AUTH_USERNAME || '';
  const password = window._env_?.REACT_APP_AUTH_PASSWORD || process.env.REACT_APP_AUTH_PASSWORD || '';
  return { username, password };
};

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedAuth = sessionStorage.getItem('workflow_auth');
    if (storedAuth === 'authenticated') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const login = (username, password) => {
    const config = getEnvConfig();

    if (!config.username || !config.password) {
      return { success: true };
    }

    if (username === config.username && password === config.password) {
      setIsAuthenticated(true);
      sessionStorage.setItem('workflow_auth', 'authenticated');
      return { success: true };
    }

    return { success: false, error: 'Invalid credentials' };
  };

  const logout = () => {
    setIsAuthenticated(false);
    sessionStorage.removeItem('workflow_auth');
  };

  const isAuthRequired = () => {
    const config = getEnvConfig();
    return !!(config.username && config.password);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, isLoading, login, logout, isAuthRequired }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
